import moment from 'moment';
import { welcomeCheckPeriodInDays } from '@/shared/lib/welcomeBonus/constants';

export function daysAgo(days: number) {
  return moment().add(-days, 'day')
    .toISOString();
}

export const getDaysLimit = () => daysAgo(welcomeCheckPeriodInDays);
export const getDaysTillEnd = (fromDate: Date) => moment(fromDate).add(welcomeCheckPeriodInDays, 'day')
  .format('YYYY-MM-DDTHH:mm:ss');
